import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { Container, Row, Col } from "bootstrap-4-react";
import { Link } from "react-router-dom";

const userRole = localStorage.getItem("userRole");
const userRoleId = localStorage.getItem("userRoleId");

const styles = (theme) => ({
  root: {
    width: "100%",
    paddingBottom: 24,
  },
  panel: {
    backgroundColor: "#fafafa",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    alignItems: "center",
  },
  column: {
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

class SurveyRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: "panel1",
    };
  }
  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { value, expanded } = this.state;
    const { classes } = this.props;

    return (
      <div className="">
        <Container className="breadCrubmContainerDashboard">
          <div className="breadCrumb">
            <Link to="/" className="prevLinks">
              Dashboard
            </Link>
            <span>&nbsp;&gt;&nbsp;</span>
            <span className="currLink">Survey Request</span>
          </div>
        </Container>
        <Container>
          <Row>
            <Col>
              <div className="headerCardRoot">
                <div className="headerCardMain cardHeading">
                  <div className="headerCardTitle">
                    <span>Survey Request</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col></Col>
          </Row>

          <div className={classes.root}>
            <ExpansionPanel
              square
              expanded={expanded === "panel1"}
              onChange={this.handleChange("panel1")}
              className={classes.panel}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <div className={classes.column}>
                  <Typography className={classes.heading}>Name</Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.heading}>
                    I would like to request a survey to be done on a *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.heading}>MM/DD/YY</Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.details}>
                <div className={classes.column}>
                  {" "}
                  <Typography className={classes.secondaryHeading}>
                    What best describes you *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>
                    What will this survey be used for *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography variant="caption">
                    Type of survey you’re looking for * Survey for Permits
                  </Typography>
                </div>
              </ExpansionPanelDetails>
              <ExpansionPanelDetails className={classes.details}>
                <div className={classes.column}>
                  {" "}
                  <Typography className={classes.secondaryHeading}>
                    Address *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>
                    Town
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography variant="caption">State</Typography>
                </div>
              </ExpansionPanelDetails>
              <Divider />
              <ExpansionPanelActions>
                <Button size="small">Cancel</Button>
                <Button size="small" color="primary">
                  Approve
                </Button>
              </ExpansionPanelActions>
            </ExpansionPanel>
            <ExpansionPanel
              square
              expanded={expanded === "panel2"}
              onChange={this.handleChange("panel2")}
              className={classes.panel}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <div className={classes.column}>
                  <Typography className={classes.heading}>Name</Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.heading}>
                    I would like to request a survey to be done on a *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.heading}>MM/DD/YY</Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.details}>
                <div className={classes.column}>
                  {" "}
                  <Typography className={classes.secondaryHeading}>
                    What best describes you *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>
                    What will this survey be used for *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography variant="caption">
                    Type of survey you’re looking for * Survey for Permits
                  </Typography>
                </div>
              </ExpansionPanelDetails>
              <ExpansionPanelDetails className={classes.details}>
                <div className={classes.column}>
                  {" "}
                  <Typography className={classes.secondaryHeading}>
                    Address *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>
                    Town
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography variant="caption">State</Typography>
                </div>
              </ExpansionPanelDetails>
              <Divider />
              <ExpansionPanelActions>
                <Button size="small">Cancel</Button>
                <Button size="small" color="primary">
                  Approve
                </Button>
              </ExpansionPanelActions>
            </ExpansionPanel>

            <ExpansionPanel
              square
              expanded={expanded === "panel3"}
              onChange={this.handleChange("panel3")}
              className={classes.panel}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <div className={classes.column}>
                  <Typography className={classes.heading}>Name</Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.heading}>
                    I would like to request a survey to be done on a *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.heading}>MM/DD/YY</Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.details}>
                <div className={classes.column}>
                  {" "}
                  <Typography className={classes.secondaryHeading}>
                    What best describes you *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>
                    What will this survey be used for *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography variant="caption">
                    Type of survey you’re looking for * Survey for Permits
                  </Typography>
                </div>
              </ExpansionPanelDetails>
              <ExpansionPanelDetails className={classes.details}>
                <div className={classes.column}>
                  {" "}
                  <Typography className={classes.secondaryHeading}>
                    Address *
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>
                    Town
                  </Typography>
                </div>
                <div className={classes.column}>
                  <Typography variant="caption">State</Typography>
                </div>
              </ExpansionPanelDetails>
              <Divider />
              <ExpansionPanelActions>
                <Button size="small">Cancel</Button>
                <Button size="small" color="primary">
                  Approve
                </Button>
              </ExpansionPanelActions>
            </ExpansionPanel>
          </div>
        </Container>
      </div>
    );
  }
}

SurveyRequest.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyRequest);



// WEBPACK FOOTER //
// ./src/pages/SurveyRequest/SurveyRequest.js